import { MapPin, Clock } from "lucide-react";

export function groupByDate(items) {
  const groups = [];
  items.forEach((it) => {
    const key = it.date || "Other";
    let g = groups.find((x) => x.key === key);
    if (!g) groups.push((g = { key, items: [] }));
    g.items.push(it);
  });
  return groups;
}

export default function ScheduleList({ items, limit }) {
  const list = limit ? items.slice(0, limit) : items;
  if (!list.length)
    return <p data-testid="schedule-empty" className="text-lg text-stone-600">The schedule will be posted here soon.</p>;
  return (
    <div className="space-y-10">
      {groupByDate(list).map((g) => (
        <section key={g.key}>
          <h3 className="font-heading text-2xl font-bold text-[#2B5338] mb-4">{g.key}</h3>
          <ol className="relative border-l-4 border-amber-300 ml-2 space-y-5">
            {g.items.map((s) => (
              <li key={s.id} data-testid={`schedule-item-${s.id}`} className="pl-6 relative">
                <span className="absolute -left-[14px] top-3 w-6 h-6 rounded-full bg-[#8C3415] border-4 border-[#FAF6F0]" />
                <div className="card-warm !p-5 sm:!p-6">
                  {(s.time || s.end_time) && (
                    <p className="flex items-center gap-2 text-[#8C3415] font-bold text-lg">
                      <Clock className="w-5 h-5" />{s.time}{s.end_time ? ` – ${s.end_time}` : ""}
                    </p>
                  )}
                  <p className="font-heading text-xl sm:text-2xl font-semibold mt-1">{s.title}</p>
                  {s.location && <p className="flex items-center gap-2 text-stone-700 mt-1"><MapPin className="w-5 h-5" />{s.location}</p>}
                  {s.description && <p className="text-lg text-stone-700 mt-2 whitespace-pre-line">{s.description}</p>}
                </div>
              </li>
            ))}
          </ol>
        </section>
      ))}
    </div>
  );
}
